import { LayoutDashboard, CalendarDays, UserRound, Users, Handshake, CalendarClock, Ticket } from "lucide-react";

export const SECTIONS = [
  { id: "overview", label: "Vue d'ensemble", hint: "Statut, informations et prochaines étapes", icon: LayoutDashboard },
  { id: "program", label: "Programme", hint: "Conférences, horaires et lieux", icon: CalendarDays },
  { id: "profile", label: "Mon profil", hint: "Présentation, entreprise et tags", icon: UserRound },
  { id: "participants", label: "Participants", hint: "Visiteurs ou exposants selon le rôle", icon: Users },
  { id: "networking", label: "Networking & Matchmaking", hint: "Demandes de rencontres et suggestions", icon: Handshake },
  { id: "meetings", label: "Mes rendez-vous", hint: "Créneaux, confirmations et agenda", icon: CalendarClock },
  { id: "documents", label: "Billetterie & Documents", hint: "Billet, facture et calendrier", icon: Ticket },
];

export const STATE_META = {
  not_registered: { label: "Non inscrit", cls: "bg-neutral-100 text-neutral-700" },
  pending: { label: "Inscription en attente", cls: "bg-amber-100 text-amber-800" },
  payment_pending: { label: "Paiement en attente", cls: "bg-amber-100 text-amber-800" },
  eligible: { label: "Inscrit", cls: "bg-emerald-100 text-emerald-800" },
  cancelled: { label: "Inscription annulée", cls: "bg-rose-100 text-rose-700" },
};
export const ROLE_LABEL = { visitor: "Visiteur", exhibitor: "Exposant", organizer: "Organisateur" };

export const REQ_META = {
  pending: { label: "En attente", cls: "bg-amber-100 text-amber-800" },
  accepted: { label: "Accepté · créneau à trouver", cls: "bg-sky-100 text-sky-800" },
  confirmed: { label: "Confirmé", cls: "bg-emerald-100 text-emerald-800" },
  declined: { label: "Refusé", cls: "bg-neutral-100 text-neutral-600" },
  cancelled: { label: "Annulé", cls: "bg-neutral-100 text-neutral-500 line-through" },
};

export const Badge = ({ meta, testId }) => <span className={`inline-flex rounded-full px-2.5 py-0.5 text-[11px] font-bold ${meta?.cls || "bg-neutral-100"}`} data-testid={testId}>{meta?.label}</span>;

export const fmtDay = (iso) => (iso ? new Date(iso).toLocaleDateString("fr-FR", { weekday: "long", day: "numeric", month: "long", year: "numeric" }) : "");
export const fmtTime = (iso) => (iso ? new Date(iso).toLocaleTimeString("fr-FR", { hour: "2-digit", minute: "2-digit" }) : "");

const icsDate = (iso) => new Date(iso).toISOString().replace(/[-:]/g, "").replace(/\.\d{3}/, "");
const icsEsc = (s) => String(s || "").replace(/([,;\\])/g, "\\$1").replace(/\n/g, "\\n");

/** Build and download an .ics file from [{uid,title,start,end,location,description}]. */
export function downloadIcs(filename, events) {
  const lines = ["BEGIN:VCALENDAR", "VERSION:2.0", "PRODID:-//La WineTech//Event Space//FR", "CALSCALE:GREGORIAN", "METHOD:PUBLISH"];
  events.filter((e) => e.start).forEach((e) => {
    const end = e.end || new Date(new Date(e.start).getTime() + 3600000).toISOString();
    lines.push("BEGIN:VEVENT", `UID:${e.uid}@lawinetech.com`, `DTSTAMP:${icsDate(new Date().toISOString())}`, `DTSTART:${icsDate(e.start)}`,
      `DTEND:${icsDate(end)}`, `SUMMARY:${icsEsc(e.title)}`, `LOCATION:${icsEsc(e.location)}`, `DESCRIPTION:${icsEsc(e.description)}`, "END:VEVENT");
  });
  lines.push("END:VCALENDAR");
  const url = URL.createObjectURL(new Blob([lines.join("\r\n")], { type: "text/calendar;charset=utf-8" }));
  const a = document.createElement("a");
  a.href = url; a.download = filename; a.click();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}

export const Card = ({ title, icon: Icon, children, action, testId, className = "" }) => (
  <section className={`rounded-2xl border border-neutral-100 bg-white p-5 shadow-sm ${className}`} data-testid={testId}>
    {(title || action) && (
      <div className="mb-3 flex items-center justify-between gap-2">
        <h2 className="inline-flex items-center gap-2 text-base font-bold text-navy">{Icon && <Icon className="h-4 w-4 text-wine-500" />}{title}</h2>
        {action}
      </div>
    )}
    {children}
  </section>
);

export const Empty = ({ children, testId }) => <p className="rounded-xl bg-neutral-50 px-4 py-6 text-center text-sm text-neutral-500" data-testid={testId}>{children}</p>;
